import React, { useEffect, useState } from "react";
import { Code, Box } from "lucide-react";
import { InboxStackIcon } from "@heroicons/react/24/outline";
import { replaceRawWithBlob } from "components/utils";
import { shortenFileName } from "components/Environment/Launchables/utils";

interface FilePieceProps {
  file: string;
  disabled: boolean;
}

export const FilePiece: React.FC<FilePieceProps> = ({ file, disabled }) => {
  const [shortFileName, setShortFileName] = useState("");

  useEffect(() => {
    const fetchShortFileName = async () => {
      const shortFileName = await shortenFileName(file);
      setShortFileName(shortFileName);
    };
    fetchShortFileName();
  }, [file]);

  return (
    <div className="flex flex-col text-sm h-full items-start">
      <div className="flex flex-row items-center text-primary">
        <InboxStackIcon className="h-6 w-6 mr-1" />
        <span>Files</span>
      </div>
      <div className="flex flex-row mt-1 w-max text-primary">
        {shortFileName}
      </div>
      <div className="flex flex-row mt-1">
        <span
          className="text-sm hover:underline text-highlight cursor-pointer"
          onClick={() => {
            if (disabled) return;
            window.open(
              replaceRawWithBlob(file) || "",
              "_blank",
              "noopener,noreferrer"
            );
          }}
        >
          View Source
        </span>
      </div>
    </div>
  );
};
